import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "container"
  }, [_c('a-card', {
    staticClass: "search-card",
    attrs: {
      "title": "筛选",
      "size": "small"
    }
  }, [_c('a-form-model', {
    ref: "searchFrom",
    attrs: {
      "model": _vm.where,
      "label-col": _vm.labelCol,
      "wrapper-col": _vm.wrapperCol
    }
  }, [_c('div', {
    staticClass: "fold"
  }, [_c('a-row', [_c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "label": "审核状态",
      "prop": "status"
    }
  }, [_c('a-select', {
    attrs: {
      "placeholder": "请选择审核状态"
    },
    model: {
      value: _vm.where.status,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "status", $$v);
      },
      expression: "where.status"
    }
  }, [_c('a-select-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("全部")]), _c('a-select-option', {
    attrs: {
      "value": 0
    }
  }, [_vm._v("通过")]), _c('a-select-option', {
    attrs: {
      "value": 1
    }
  }, [_vm._v("不通过")]), _c('a-select-option', {
    attrs: {
      "value": 2
    }
  }, [_vm._v("待审核")]), _c('a-select-option', {
    attrs: {
      "value": 3
    }
  }, [_vm._v("驳回")])], 1)], 1)], 1), _c('a-col', {
    attrs: {
      "span": 8
    }
  }, [_c('a-form-model-item', {
    style: {
      marginBottom: '5px'
    },
    attrs: {
      "prop": "query",
      "label": "搜索"
    }
  }, [_c('a-input', {
    directives: [{
      name: "emoji",
      rawName: "v-emoji"
    }],
    attrs: {
      "placeholder": "请输入反馈人员"
    },
    model: {
      value: _vm.where.query,
      callback: function callback($$v) {
        _vm.$set(_vm.where, "query", $$v);
      },
      expression: "where.query"
    }
  })], 1)], 1)], 1)], 1), _c('span', {
    staticClass: "search-button"
  }, [_c('a-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.fetch({
          current: 1,
          pageSize: 10
        });
      }
    }
  }, [_vm._v("查询")]), _c('a-button', {
    staticClass: "reset",
    on: {
      "click": function click($event) {
        return _vm.$refs.searchFrom.resetFields();
      }
    }
  }, [_vm._v("重置")])], 1)])], 1), _c('a-card', {
    attrs: {
      "title": "列表",
      "size": "small",
      "bordered": false
    }
  }, [_c('a-table', {
    staticClass: "table-card-view",
    attrs: {
      "size": "middle",
      "row-key": function rowKey(row, index) {
        return row.id + "".concat(index);
      },
      "columns": _vm.columns,
      "pagination": _vm.pagination,
      "loading": _vm.loading,
      "data-source": _vm.data,
      "bordered": "",
      "scroll": {
        y: 500
      }
    },
    on: {
      "change": _vm.onChange
    },
    scopedSlots: _vm._u([{
      key: "feedbackUser",
      fn: function fn(text, row) {
        return [_c('div', {
          staticClass: "text-ellipsis",
          attrs: {
            "title": "".concat(row.userName, "(").concat(row.organName, "/").concat(row.postName, ")")
          }
        }, [_vm._v(" " + _vm._s(row.userName) + " (" + _vm._s(row.organName) + " / " + _vm._s(row.postName) + ") ")])];
      }
    }, {
      key: "currAuditNode",
      fn: function fn(text, row) {
        return [_c('div', {
          staticClass: "text-ellipsis",
          attrs: {
            "title": "".concat(row.nodeUserName || '', "(").concat(row.nodeOrgName, "/").concat(row.nodePostName, ")")
          }
        }, [_vm._v(" " + _vm._s(row.nodeUserName) + " (" + _vm._s(row.nodeOrgName) + " / " + _vm._s(row.nodePostName) + ") ")])];
      }
    }, {
      key: "auditStatus",
      fn: function fn(text, row) {
        return [0 === row.auditStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("通　过")]) : _vm._e(), 1 === row.auditStatus ? _c('a-tag', {
          staticClass: "tag-red"
        }, [_vm._v("不通过")]) : _vm._e(), 2 === row.auditStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待审核")]) : _vm._e(), 3 === row.auditStatus ? _c('a-tag', {
          staticClass: "tag-orange"
        }, [_vm._v("驳　回")]) : _vm._e()];
      }
    }, {
      key: "noticeStatus",
      fn: function fn(text, row) {
        return [0 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("草　稿")]) : _vm._e(), 1 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-blue"
        }, [_vm._v("待审核")]) : _vm._e(), 2 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-green"
        }, [_vm._v("通　过")]) : _vm._e(), 3 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-red"
        }, [_vm._v("不通过")]) : _vm._e(), 4 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-grey"
        }, [_vm._v("撤　回")]) : _vm._e(), 5 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-purple"
        }, [_vm._v("已发布")]) : _vm._e(), 6 === row.noticeStatus ? _c('a-tag', {
          staticClass: "tag-shallow-orange"
        }, [_vm._v("审核中")]) : _vm._e()];
      }
    }, {
      key: "action",
      fn: function fn(text, row) {
        return [_c('a-dropdown', {
          attrs: {
            "trigger": ['click']
          }
        }, [_c('a', {
          staticClass: "ant-dropdown-link",
          on: {
            "click": function click(e) {
              return e.preventDefault();
            }
          }
        }, [_vm._v(" 操作"), _c('a-icon', {
          attrs: {
            "type": "down"
          }
        })], 1), _c('a-menu', {
          attrs: {
            "slot": "overlay"
          },
          slot: "overlay"
        }, [_c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.view(row);
            }
          }
        }, [_vm._v("查看")])], 1), 2 === row.auditStatus ? _c('a-menu-item', [_c('a-button', {
          attrs: {
            "type": "link"
          },
          on: {
            "click": function click($event) {
              return _vm.audit(row);
            }
          }
        }, [_vm._v(" 审核 ")])], 1) : _vm._e()], 1)], 1)];
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };